import { StatusDropDownOption } from './StatusDropdown.interfaces';
import { Statuses } from '../../Status';

export const defaultStatuses: StatusDropDownOption[] = Object.entries(Statuses).map(([key, value]) => {
  return {
    caption: value,
    value: key
  } as StatusDropDownOption;
});
